import { React } from 'react'
import i18n from 'i18next'
import { Tooltip, Checkbox } from 'antd'

import classNames from 'classnames'
import { store as reduxStore } from 'index'

import { isGlobal } from 'conf'
import groupBlackSVG from '@/assets/images/group-black-24.svg'
import { SRC_TYPE } from '../components/helper'

const getTableInfo = (
  styles,
  userList,
  selectedRowKeys,
  onSelectChange,
  isOwnerType = false,
  renderMenu = null,
  hideRoleTag = false,
  allowSelfSelect = false,
  allowOwnerSelect = false,
) => {
  const reduxState = reduxStore.getState()
  const { email: reduxEmail } = reduxState.user

  const onRow = (record /* , rowIndex */) => {
    return {
      onClick: (e) => {
        // owner/선택 불가 사용자는 클릭 무시
        const { role: userRole } = record.originData || {}
        const isOwner =
          (!allowOwnerSelect && (userRole === 'owner' || record.sourceType === SRC_TYPE.GROUP_OWNER)) ||
          (!allowSelfSelect && record.email === reduxEmail)

        if (isOwner) {
          return
        }

        // 체크박스나 버튼 클릭이 아닌 경우에만 선택 토글
        if (e.target.type !== 'checkbox' && !e.target.closest('.ant-checkbox-wrapper')) {
          const key = record.key || record.id
          const isSelected = selectedRowKeys && selectedRowKeys.includes(key)

          if (onSelectChange) {
            if (isSelected) {
              onSelectChange(
                selectedRowKeys.filter((k) => k !== key),
                selectedRowKeys.filter((k) => k !== key).map(() => record),
              )
            } else {
              onSelectChange(
                [...(selectedRowKeys || []), key],
                [...(selectedRowKeys || []), key].map(() => record),
              )
            }
          }
        }
      },
    }
  }

  const nameList = (id) => {
    const group = userList?.find((value) => value.id === id)
    return group ? group.member.map((member) => member.user_name) : []
  }

  const role = (roleType) => {
    if (roleType === 'owner') {
      return <span className={classNames(styles.owner)}>{i18n.t('member.column.owner')}</span>
    }
    if (roleType === 'admin') {
      return <span className={classNames(styles.admin)}>{i18n.t('member.column.admin')}</span>
    }
    return null
  }

  const columns = [
    {
      dataIndex: 'avatarUrl',
      key: 'avatar',
      width: 48,
      render: (_, record) => {
        const avatarUrl = () => {
          if (isGlobal()) {
            return record?.originData?.avatar_url ?? record.avatarUrl
          }
          return record.avatarUrl
        }

        if (record.type === 'group') {
          return (
            <span className={classNames(styles.imageWrapper)}>
              <img
                src={groupBlackSVG}
                alt={record.name}
                className={classNames(styles.groupImage)}
                style={{ borderRadius: '0' }}
              />
            </span>
          )
        }
        return (
          <img src={avatarUrl()} alt={record.name} className={classNames(styles.personImage)} />
        )
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        const { name, email, id, role: recordRole, sourceType } = record
        const { role: roleType } = record.originData
        const list = nameList(id).join(', ')

        return (
          <div className={classNames(styles.info)}>
            <div className={classNames(styles.nameContents)} style={{ fontWeight: '500' }}>
              <Tooltip title={list}>
                <span className={classNames(styles.name)}>{name}</span>
              </Tooltip>
              {!hideRoleTag && role(roleType || recordRole)}

              {isOwnerType && sourceType === SRC_TYPE.OWNER && (
                <div className={classNames(styles.sourceTypeOwner)}>
                  {i18n.t('member.column.owner')}
                </div>
              )}

              {record.expired && (
                <div className={classNames(styles.sourceTypeOwner)} style={{ color: '#FD4C45' }}>
                  {i18n.t('workspace.field.expired')}
                </div>
              )}
            </div>
            <span className={classNames(styles.email)}>{email}</span>
          </div>
        )
      },
    },
    // 체크박스 컬럼 - selectedRowKeys와 onSelectChange가 있을 때만 표시
    ...(selectedRowKeys !== undefined && onSelectChange
      ? [
          {
            key: 'selection',
            width: 48,
            render: (_, record) => {
              const key = record.key || record.id
              const isSelected = selectedRowKeys && selectedRowKeys.includes(key)

              // Owner role이거나 sourceType이 GROUP_OWNER인 경우 체크박스 숨김
              const { role: userRole } = record.originData || {}
              const isOwner =
                (!allowOwnerSelect && (userRole === 'owner' || record.sourceType === SRC_TYPE.GROUP_OWNER)) ||
                (!allowSelfSelect && record.email === reduxEmail)

              if (isOwner) {
                return null
              }

              return (
                <Checkbox
                  checked={isSelected}
                  onChange={(e) => {
                    e.stopPropagation()
                    const { checked } = e.target

                    if (onSelectChange) {
                      if (checked) {
                        onSelectChange(
                          [...(selectedRowKeys || []), key],
                          [...(selectedRowKeys || []), key].map(() => record),
                        )
                      } else {
                        onSelectChange(
                          (selectedRowKeys || []).filter((k) => k !== key),
                          (selectedRowKeys || []).filter((k) => k !== key).map(() => record),
                        )
                      }
                    }
                  }}
                />
              )
            },
          },
        ]
      : []),
    // 메뉴 컬럼 - renderMenu가 있을 때만 표시
    ...(renderMenu
      ? [
          {
            key: 'menu',
            width: 24,
            render: (_, record) => renderMenu(record),
          },
        ]
      : []),
  ]

  return { columns, onRow }
}

export default getTableInfo
